import {
  IMPEDIMENTO_PRAZO_DO_DOSSIE,
  obterAcoesDaSituacao,
  SITUACOES,
} from './utils/fluxoDoBonusMoradia';
import mapearHistoricoDoStatusParaLinhaDoTempo from './utils/mapearHistoricoDoStatusParaLinhaDoTempo';
import {
  obterPermissaoDaAcao,
  PERMISSAO_PARA_PRORROGAR_PRAZO,
} from './utils/permissoesDoBonusMoradia';
import { obterSituacaoDoPrazoDoDossie } from './utils/prazoDoDossie';
import FiltrosDaTela, {
  TELA_LISTA_DE_SOLICITACOES,
} from '../../../utils/filtrosDaTela';

const SITUACOES_QUE_PERMITEM_EDITAR_VALORES = [
  SITUACOES.SOLICITADO,
  SITUACOES.RESERVADO,
  SITUACOES.PROTOCOLADO,
  SITUACOES.INCONFORME,
];

const somenteObservacao =valores => ({
  Observacao: valores.observacao || null,
});

const ROTAS_DAS_ACOES = {
  protocolarRecebimento: {
    caminho: 'ProtocolacaoDoRecebimento',
    corpo: valores => ({
      DataDocumental: valores.dataDocumental,
      Observacao: valores.observacao || null,
    }),
    mensagemDeSucesso: 'O recebimento foi protocolado com sucesso',
  },
  iniciarAnalise: {
    caminho: 'InicioDaAnalise',
    corpo: somenteObservacao,
    mensagemDeSucesso: 'A análise foi iniciada com sucesso',
  },
  marcarComoConforme: {
    caminho: 'MarcacaoDeConformidade',
    corpo: valores => ({
      NumeroDoProcesso: valores.numeroDoProcesso,
      Observacao: valores.observacao || null,
    }),
    mensagemDeSucesso: 'A conformidade foi registrada com sucesso',
  },
  marcarComoInconforme: {
    caminho: 'MarcacaoDeInconformidade',
    corpo: valores => ({ Justificativa: valores.justificativa }),
    mensagemDeSucesso: 'A pendência foi registrada com sucesso',
  },
  retomarAnalise: {
    caminho: 'RetomadaDaAnalise',
    corpo: somenteObservacao,
    mensagemDeSucesso: 'A análise foi retomada com sucesso',
  },
  encaminharParaEmpenho: {
    caminho: 'EncaminhamentoParaEmpenho',
    corpo: somenteObservacao,
    mensagemDeSucesso: 'A solicitação foi encaminhada para empenho',
  },
  registrarEmpenho: {
    caminho: 'RegistroDeEmpenho',
    corpo: somenteObservacao,
    mensagemDeSucesso: 'O empenho foi registrado com sucesso',
  },
  gerarMinutaDoContrato: {
    caminho: 'GeracaoDaMinutaDoContrato',
    corpo: somenteObservacao,
    mensagemDeSucesso: 'A minuta do contrato foi gerada com sucesso',
  },
  encaminharAoGabinete: {
    caminho: 'EncaminhamentoAoGabinete',
    corpo: somenteObservacao,
    mensagemDeSucesso: 'O contrato foi encaminhado ao gabinete',
  },
  encaminharAConstrutora: {
    caminho: 'EncaminhamentoAConstrutora',
    corpo: somenteObservacao,
    mensagemDeSucesso: 'O contrato foi encaminhado à construtora',
  },
  registrarRetornoDaConstrutora: {
    caminho: 'RegistroDeRetornoDaConstrutora',
    corpo: somenteObservacao,
    mensagemDeSucesso: 'O retorno da construtora foi registrado com sucesso',
  },
  registrarAssinatura: {
    caminho: 'RegistroDeRetornoDoGabinete',
    corpo: somenteObservacao,
    mensagemDeSucesso: 'O retorno do gabinete foi registrado com sucesso',
  },
  registrarPagamento: {
    caminho: 'RegistroDePagamento',
    corpo: valores => ({
      OrdemBancaria: valores.ordemBancaria,
      DataDoPagamento: valores.dataDoPagamento,
      OrdemBancariaComplementar: valores.ordemBancariaComplementar || null,
      Observacao: valores.observacao || null,
    }),
    mensagemDeSucesso: 'O pagamento foi registrado e o subsídio liquidado',
  },
  indeferir: {
    caminho: 'Indeferimento',
    corpo: valores => ({ Justificativa: valores.justificativa }),
    mensagemDeSucesso: 'A solicitação foi indeferida',
  },
};

export default {
  data() {
    return {
      solicitacao: {},
      proponentes: [],
      financiamento: {},
      informacoesDoPagamento: null,
      imovel: {},
      rendaTotal: null,
      rendaTotalComprovada: null,
      descontoDaConstrutora: null,
      valorDaCompraEVenda: null,
      valorDoFinanciamentoAprovado: null,
      subsidioDaAgehab: null,
      subsidioDoGovernoFederal: null,
      fgtsDoSolicitante: null,
      participacaoDoSolicitante: null,
      historicoDoStatus: null,
      solicitacaoEhDoBonusMoradia: false,
      loading: { visivel: true },
      status: null,
      construtora: {},
      cidade: {},
      empreendimento: {},
      numeroDoProcesso: null,
      existeNumeroDoProcesso: false,
      mensagemVisivel: false,
      textoMensagem: '',
      estiloMensagem: '',
      tituloMensagem: '',
      operacaoBancaria: null,
      operacaoBancariaComplementar: null,
      origemDaAssinatura: null,
      ehCapital: false,
      usuarioSolicitanteLogin: null,
      projetoExigeNumeroDoProcesso: false,
      acaoEmAndamento: null,
      dataDocumental: null,
      prazoDoDossie: null,
    };
  },
  computed: {
    itensDaLinhaDoTempo() {
      return mapearHistoricoDoStatusParaLinhaDoTempo(
        this.historicoDoStatus || [],
        this.informacoesDoPagamento,
        this.numeroDoProcesso,
        this.dataDocumental,
        this.prazoDoDossie,
      );
    },
    nomeDoTitular() {
      const titular = this.proponentes[0];
      return (titular && titular.Nome) || this.subsidioDaAgehab;
    },
    prazoDoDossieVencido() {
      return (
        this.status === SITUACOES.PRAZO_DOSSIE_VENCIDO ||
        this.status === SITUACOES.PRAZO_DOSSIE_VENCIDO_PRORROGACAO
      );
    },
    situacaoDoPrazoDoDossie() {
      const situacao = obterSituacaoDoPrazoDoDossie(this.status, this.prazoDoDossie);

      if (!situacao || this.possuiPermissaoParaProrrogarPrazo()) {
        return situacao;
      }

      return Object.assign({}, situacao, { rotuloBotaoProrrogar: null });
    },
    acoesDaSituacao() {
      if (!this.solicitacaoEhDoBonusMoradia) return [];

      const impedimentos = {
        [IMPEDIMENTO_PRAZO_DO_DOSSIE]: this.prazoDoDossieVencido,
      };

      return obterAcoesDaSituacao(this.status, impedimentos, this.ehCapital).filter(acao =>
        this.possuiPermissaoParaAcao(acao),
      );
    },
    possuiAcoesDaSituacao() {
      return this.acoesDaSituacao.length > 0;
    },
  },
  methods: {
    carregarSolicitacao() {
      this.loading.visivel = true;
      const idDaSolicitacao = this.$route.query.idDaSolicitacao;

      this.$api
        .get(`/solicitacao/${idDaSolicitacao}`)
        .then((response) => {
          const solicitacao = response.data;
          this.solicitacao = solicitacao;
          this.proponentes = solicitacao.Proponentes;
          this.financiamento = solicitacao.Financiamento;
          this.informacoesDoPagamento = solicitacao.InformacoesDoPagamento;
          this.imovel = solicitacao.Imovel;
          this.construtora = solicitacao.Imovel.Empreendimento.Construtora;
          this.cidade = solicitacao.Imovel.Endereco.Cidade;
          this.empreendimento = solicitacao.Imovel.Empreendimento;
          this.status = solicitacao.Status;
          this.historicoDoStatus = solicitacao.HistoricoDoStatus;
          this.rendaTotal = this.$moeda.formatar(solicitacao.RendaTotal);
          this.valorDaCompraEVenda = this.$moeda.formatar(this.financiamento.ValorDaCompraEVenda);
          this.valorDoFinanciamentoAprovado = this.$moeda.formatar(
            this.financiamento.ValorDoFinanciamentoAprovado,
          );
          this.subsidioDaAgehab = this.$moeda.formatar(this.financiamento.SubsidioDaAgehab);
          this.subsidioDoGovernoFederal = this.$moeda.formatar(
            this.financiamento.SubsidioDoGovernoFederal,
          );
          this.fgtsDoSolicitante = this.$moeda.formatar(this.financiamento.FgtsDoSolicitante);
          this.participacaoDoSolicitante = this.$moeda.formatar(
            this.financiamento.ParticipacaoDoSolicitante,
          );
          this.solicitacaoEhDoBonusMoradia = solicitacao.EhBonusMoradia;
          this.rendaTotalComprovada = this.$moeda.formatar(solicitacao.RendaTotalComprovada);
          this.descontoDaConstrutora = this.$moeda.formatar(this.financiamento.DescontoConstrutora);
          this.usuarioSolicitanteLogin = solicitacao.UsuarioSolicitanteLogin;
          this.projetoExigeNumeroDoProcesso = solicitacao.ProjetoExigeNumeroDoProcesso;
          this.numeroDoProcesso = solicitacao.NumeroDoProcesso;
          this.existeNumeroDoProcesso = solicitacao.NumeroDoProcesso !== null;
          this.operacaoBancaria = solicitacao.OperacaoBancaria;
          this.operacaoBancariaComplementar = solicitacao.OperacaoBancariaComplementar;
          this.origemDaAssinatura = solicitacao.OrigemDaAssinatura;
          this.ehCapital = solicitacao.EhCapital;
          this.dataDocumental = solicitacao.DataDocumental;
          this.prazoDoDossie = solicitacao.PrazoDoDossie;
        })
        .catch((error) => {
          this.tratarErro(error);
        })
        .finally(() => {
          this.esconderCarregamento();
        });
    },
    possuiPermissaoParaAcao(acao) {
      const permissao = obterPermissaoDaAcao(acao.chave, this.status);
      if (!permissao) return false;

      return this.$usuario.possuiPermissao(permissao);
    },
    possuiPermissaoParaProrrogarPrazo() {
      return this.$usuario.possuiPermissao(PERMISSAO_PARA_PRORROGAR_PRAZO);
    },
    executarAcaoDaSituacao(acao) {
      this.acaoEmAndamento = acao;
    },
    fecharDialogoDeSituacao() {
      this.acaoEmAndamento = null;
    },
    confirmarAcaoDaSituacao({ acao, valores }) {
      const acoesComMetodoProprio = {
        reservar: this.reservarSubsidio,
      };

      this.fecharDialogoDeSituacao();

      const executar = acoesComMetodoProprio[acao.chave];
      if (executar) {
        executar(valores);
        return;
      }

      this.executarAcaoDoFluxo(acao, valores);
    },
    executarAcaoDoFluxo(acao, valores) {
      const rota = ROTAS_DAS_ACOES[acao.chave];
      if (!rota) return;

      const idDaSolicitacao = this.$route.query.idDaSolicitacao;
      this.exibirCarregamento('Só um momento, estamos registrando a movimentação');

      this.$api
        .post(`/solicitacao/${idDaSolicitacao}/${rota.caminho}`, rota.corpo(valores))
        .then(() => {
          this.carregarSolicitacao();
          this.exibirMensagemDeSucesso(rota.mensagemDeSucesso);
        })
        .catch((error) => {
          this.tratarErro(error);
        });
    },
    podeEditar() {
      return (
        SITUACOES_QUE_PERMITEM_EDITAR_VALORES.includes(this.status) &&
        this.$usuario.possuiPermissao('EditarValoresDoSubsidio') &&
        this.solicitacaoEhDoBonusMoradia &&
        this.usuarioSolicitanteLogin === this.$usuario.obterUsuarioLogado().login
      );
    },
    podeAlterarNup() {
      return this.$usuario.possuiPermissao('Protocolacao') && this.existeNumeroDoProcesso;
    },
    prorrogar({ dataDeRecebimentoDoOficio, observacao }) {
      const idDaSolicitacao = this.$route.query.idDaSolicitacao;
      const corpo = {
        DataDeRecebimentoDoOficio: dataDeRecebimentoDoOficio,
        Observacao: observacao || null,
      };
      this.exibirCarregamento('Só um momento, estamos registrando a prorrogação');
      return this.$api
        .post(`/solicitacao/${idDaSolicitacao}/Prorrogar`, corpo)
        .then(() => {
          this.carregarSolicitacao();
          this.exibirMensagemDeSucesso(
            'O prazo para envio do dossiê foi atualizado.',
            'Prazo prorrogado com sucesso!',
          );
        })
        .catch((error) => {
          this.tratarErro(error);
          throw error;
        });
    },
    reservarSubsidio(valores) {
      const idDaSolicitacao = this.$route.query.idDaSolicitacao;
      const corpo = { Observacao: (valores && valores.observacao) || null };
      this.$api
        .post(`/solicitacao/BonusMoradia/${idDaSolicitacao}/Reservar`, corpo)
        .then(() => {
          this.carregarSolicitacao();
          this.exibirMensagemDeSucesso('O subsídio foi reservado com sucesso');
        })
        .catch((error) => {
          this.tratarErro(error);
        });
    },
    podeAutorizarPagamento() {
      return (
        this.status === SITUACOES.RESERVADO &&
        !this.solicitacaoEhDoBonusMoradia &&
        this.$usuario.possuiPermissao('AprovarSolicitacao')
      );
    },
    autorizarPagamento({ ordemBancaria, dataDoPagamento }) {
      const idDaSolicitacao = this.$route.query.idDaSolicitacao;
      const dadosDoFormularioDeAutorizacaoDePagamento = {
        dataDoPagamento: this.$tempo.formatarDataParaAPI(dataDoPagamento),
        ordemBancaria,
      };
      this.exibirCarregamento('Só um momento, estamos registrando o pagamento no sistema');
      return this.$api
        .post(
          `/solicitacao/${idDaSolicitacao}/AutorizarPagamento`,
          dadosDoFormularioDeAutorizacaoDePagamento,
        )
        .then(() => {
          this.carregarSolicitacao();
          this.exibirMensagemDeSucesso('O pagamento foi autorizado com sucesso');
        })
        .catch((error) => {
          this.tratarErro(error);
          throw error;
        });
    },
    redirecionarParaEdicao() {
      const idDaSolicitacao = this.$route.query.idDaSolicitacao;
      this.$router.push({
        name: 'EditarValoresDaSolicitacao',
        query: { idDaSolicitacao },
      });
    },
    alterarNup(novoNumeroDoProcesso) {
      const idDaSolicitacao = this.$route.query.idDaSolicitacao;
      const urlDeAlteracaoDeNup = `/solicitacao/${idDaSolicitacao}/Protocolacao`;
      this.exibirCarregamento('Só um momento, estamos atualizando o NUP da solicitação');

      return this.$api
        .post(urlDeAlteracaoDeNup, {
          NumeroDoProcesso: novoNumeroDoProcesso,
        })
        .then(() => {
          this.exibirMensagemDeSucesso('O NUP foi atualizado com sucesso');
        })
        .catch((error) => {
          this.tratarErro(error);
          throw error;
        })
        .finally(() => {
          this.carregarSolicitacao();
        });
    },
    tratarErro(error) {
      const mensagensDeErro = error.response && error.response.data && error.response.data.Message;
      let mensagem;

      if (mensagensDeErro) mensagem = mensagensDeErro.split(',').join('<br />');
      else {
        mensagem = 'Desculpe, ocorreu um erro interno. Tente novamente ou contate o suporte';
      }

      this.exibirMensagemDeErro(mensagem);
      this.esconderLoadingESubirATela();
    },
    exibirCarregamento(mensagem) {
      this.loading.visivel = true;
      this.loading.mensagem = mensagem;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
      this.loading.mensagem = null;
    },
    exibirMensagemDeErro(mensagem) {
      this.exibirMensagem(mensagem, 'erro');
    },
    exibirMensagemDeSucesso(mensagem, titulo = 'Concluído') {
      this.exibirMensagem(mensagem, 'sucesso', titulo);
    },
    exibirMensagem(mensagem, estiloDaMensagem, tituloDaMensagem) {
      this.mensagemVisivel = true;
      this.textoMensagem = mensagem;
      this.estiloMensagem = estiloDaMensagem;
      this.tituloMensagem = tituloDaMensagem || '';
      setTimeout(() => {
        this.fecharMensagem();
      }, 10000);
    },
    fecharMensagem() {
      this.mensagemVisivel = false;
    },
    esconderLoadingESubirATela() {
      this.esconderCarregamento();
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.carregarSolicitacao();
  },
  beforeDestroy() {
    if (window.location.href.indexOf('lista-de-solicitacoes') === -1) {
      FiltrosDaTela.remover(TELA_LISTA_DE_SOLICITACOES);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/controle-de-solicitacoes/detalhes-da-solicitacao/mixinSolicitacao.js